if (!customElements.get('td-marquise')) {
class TDMarquise extends HTMLElement {
  connectedCallback() {
      this.track = this.querySelector('.td-track'); 
      this.trackWidth = this.track.offsetWidth;

      this.duplicateTrackIfNeeded();

      window.addEventListener('resize', () => this.duplicateTrackIfNeeded());
  }

  duplicateTrackIfNeeded() {
    if (this.trackWidth < window.innerWidth * 2) {
      do {
        const newTrack = this.track.cloneNode(true);
        this.track.parentNode.appendChild(newTrack);
        this.trackWidth += this.track.offsetWidth;
      } while (this.trackWidth < window.innerWidth * 2);
    }
  }
}

customElements.define('td-marquise', TDMarquise);
}